/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum NotificationType {
  EmailOnly = "EmailOnly",
  TextOnly = "TextOnly",
  BothTextAndEmail = "BothTextAndEmail",
}

export const NotificationTypeDisplay: Record<NotificationType, string> = {
  [NotificationType.EmailOnly]: "Email Only",
  [NotificationType.TextOnly]: "Text Only",
  [NotificationType.BothTextAndEmail]: "Both Text & Email",
};
